/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { type ReactNode, useContext } from 'react';
import { SnippetsSection } from '../Snippets/SnippetsSection';
import type { SnippetsSectionProps } from '../Snippets/types';
import { SECTION_NAME_LICENSE, SECTION_NAME_LICENSE_OPTIONAL } from '../../../constants/snippetsSectionNames';
import { CreateAccountBanner } from '../CreateAccountBanner/CreateAccountBanner';
import { CustomerPortalContext } from '../../../contexts/CustomerPortalContext';

export function SnippetsPremiumSection( {
	number,
	allFeaturesAvailableInPlan,
	arePremiumFeaturesSelected
}: SnippetsSectionProps ): ReactNode {
	const { isLoggedIn } = useContext( CustomerPortalContext );

	return (
		<SnippetsSection
			headerCharacter={ number }
			title={ !isLoggedIn && !arePremiumFeaturesSelected ? SECTION_NAME_LICENSE_OPTIONAL : SECTION_NAME_LICENSE }
		>
			<CreateAccountBanner
				allFeaturesAvailableInPlan={ allFeaturesAvailableInPlan }
				arePremiumFeaturesSelected={ arePremiumFeaturesSelected }
				signUpVariant='steps'
			/>
		</SnippetsSection>
	);
}
